export const AUTH_CHANGED_EVENT = "visa-portal-auth-changed";

const PUBLIC_PATHS = new Set(["/", "/login", "/register", "/privacy-policy"]);

export function getToken() {
  return localStorage.getItem("token");
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export function getDisplayName(user = getStoredUser()) {
  if (!user) return "User";
  return (
    user.name ||
    user.username ||
    user.full_name ||
    user.email ||
    "User"
  );
}

export function isAuthenticated() {
  return Boolean(getToken());
}

export function clearAuth() {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
}

export function setAuth(token, user) {
  localStorage.setItem("token", token);
  if (user) {
    localStorage.setItem("user", JSON.stringify(user));
  }
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
}

export function isPublicPath(pathname) {
  const path = String(pathname || "").trim().toLowerCase();
  return PUBLIC_PATHS.has(path) || path.startsWith("/admin/jasim/");
}

export function isAuthApiError(error) {
  const status = error?.response?.status;
  const message = String(error?.response?.data?.message || "");

  if (status === 401) {
    return true;
  }

  if (status === 403 && /token/i.test(message)) {
    return true;
  }

  return false;
}

export function redirectToLogin() {
  if (isPublicPath(window.location.pathname)) {
    return;
  }

  window.location.replace("/login");
}
